import './App.css';

import useWindowDimensions from "./useWindowDimensions";

import ChordDiagram from "./ChordDiagram";

// Load raw data
const API_KEY = process.env.REACT_APP_SHEETS_API_KEY;
const SPREADSHEET_ID = "1NhRMjoNgEMyl96WFuXUZ_BK3DS-tCl12ZA4jhbxR9hQ";
const SHEET_NAME = "Old for TB"
const raw_data = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}/values/${SHEET_NAME}?key=${API_KEY}`)
                             .then(response => response.json())
                             .then(data => data.values);
const raw_url_data = await fetch(`https://sheets.googleapis.com/v4/spreadsheets/${SPREADSHEET_ID}?ranges='${SHEET_NAME}'!A:A&key=${API_KEY}&fields=sheets(data(rowData(values(hyperlink))))`)
                             .then(response => response.json())
                             .then(data => data.sheets[0].data[0].rowData)
                             .then(rowData => rowData.map(x => Object.keys(x).length ? x.values[0].hyperlink : ""));

// Find end of table
let last_nonempty_row;
for (let i = 0; i < raw_data.length; i++) {
  if (raw_data[i].length !== 0) {
    last_nonempty_row = i;
  } else if (raw_data[i].length === 0 || raw_data[i][0] === "") {
    break;
  }
}

// Trim empty rows and summary row
const data_w_headers = raw_data.slice(0, last_nonempty_row+1);
let url_data = [];
for (let j = 0; j < last_nonempty_row+1; j++) {
  url_data.push((j in raw_url_data) ? raw_url_data[j] : "");
}
// FYI
console.log(data_w_headers)
console.log(url_data)

// Extract name headers, and put trips in ascending order
const data_names    = data_w_headers[0].slice(2);
const data_wo_names = data_w_headers.slice(1).reverse();
const urls          = url_data.reverse();

// Extract trip headers
const trip_dates        = data_wo_names.map((row) => row[0]);
const trip_key_memories = data_wo_names.map((row) => row[1]);
const data_wo_headers   = data_wo_names.map((row) => row.slice(2));

// Convert to binary
const data_binary = data_wo_headers.map(row => {
  const row_binary = row.map(entry => {switch(entry) {
    case "": return 0;
    default: return parseInt(entry);
  }});
  while (row_binary.length < data_names.length) {
    row_binary.push(0);
  }
  return row_binary;
});

function App() {

  // Get layout
  const { height: vh, width: vw } = useWindowDimensions();
  // portrait layout:
  //  _________
  // |         |
  // | 900x900 |
  // |_________|
  // | 900*100 |
  // |_________|
  // | 900*100 |
  // |_________|   total: 900 * 1100
  //
  // landscape layout:
  //  ____________
  // |         |  |
  // | 900x900 |  | 100*900
  // |_________|__|
  // |  1000*100  |
  // |____________|   total: 1000x1000
  //
  // If vw > vh, use landscape (margins at left and right)
  // If vh > vw*1100/900, use portrait (margins at top and bottom)
  // Else:
  //   // portrait viewport but almost square
  //   svg_diam_landscape := width*0.9
  //   svg_diam_portrait := height*0.9/1.1
  //   cross over point when these two are equal
  //   i.e. width*0.9 == height*0.9/1.1
  //   i.e. height == width*1.1
  let height, width, orient, centre_x, centre_y, order_buttons_margin;
  if (vh > vw * 1.1) {
    // Portrait
    orient = "portrait";
    if (vh > vw*1.1/0.9) {
      // Margins on top and bottom
      width = 900;
      height = width*vh/vw;
      order_buttons_margin = vh*0.5 + vw*0.5;
    } else {
      // Margins on left and right
      height = 1100;
      width = height*vw/vh;
      order_buttons_margin = vh/1.1;
    }
    centre_x = width/2;
    centre_y = height/2 - 100;
  } else {
    // Landscape
    // Height is 1100, width is based off that.
    orient = "landscape";
    if (vw > vh) {
      // Margins on left and right
      height = 1000;
      width = height*vw/vh;
    } else {
      // Margins on top and bottom.
      width = 1000;
      height = width*vh/vw;
    }
    centre_x = width/2 - 50;
    centre_y = height/2 - 50;
    order_buttons_margin = vh*0.9;
  }
  const radius_off_screen = Math.sqrt((height - centre_y)**2 + (width - centre_x)**2);

  return (
    <div className="App">
      <ChordDiagram width={width}
                    height={height}
                    orient={orient}
                    centre_x={centre_x}
                    centre_y={centre_y}
                    order_buttons_margin={order_buttons_margin}
                    radius_off_screen={radius_off_screen}
                    data_names={data_names}
                    trip_dates={trip_dates}
                    trip_key_memories={trip_key_memories}
                    data_binary={data_binary}
                    hammock_diary_urls={urls}/>
    </div>
  );
}

export default App;
